<div class="simulation-info-page">
  <app-header></app-header>

  <main class="simulation-info-content">
    <div class="content-box">

      <!-- Cabeçalho com título e botão -->
      <div class="admin-header">
        <h2 class="box-title">Painel Administrativo</h2>
        <button class="nova-campanha-btn" (click)="openNovaCampanhaModal()">
          <span class="plus-sign">+</span>
          <span class="btn-text">Nova Campanha</span>
        </button>
      </div>

      <app-leads-table class="admin-campaigns-table" [columns]="tableColumns" [data]="tableData" [filterConfig]="filterConfig" filterMode="admin"
        [adminFilterOptions]="adminFilterOptions" (adminSearchChange)="onAdminSearchChange($event)"
        (pageChange)="onPageChange($event)" (pageSizeChange)="onPageSizeChange($event)"
        (viewLeadClick)="onViewLead($event)" (dateRangeChange)="onDateRangeChange($event)"
        (clearAllFilters)="onClearAllFilters()" (sortChange)="onSortChange($event)"
        (switchChange)="onSwitchChange($event)" (actionClick)="onActionClick($event)" [loading]="loading"
        [emptyMessage]="emptyMessage" [errorMessage]="errorMessage" actionButtonLabel="Consultar"
        [sortableColumns]="adminSortableColumns" [toggleSortOnly]="true" priorityField="idTipoCampanha"
        [priorityIds]="prioritizedTypeIds"
        (mousemove)="onAdminTooltipMouseMove($event)"
        (mouseleave)="onAdminTooltipMouseLeave()">
      </app-leads-table>

      <div
        *ngIf="showDisabledEditTooltip"
        class="admin-disabled-tooltip"
        [style.left.px]="tooltipMouseX"
        [style.top.px]="tooltipMouseY">
        {{ disabledTooltipMessage }}
      </div>

      <div
        *ngIf="showTextTooltip && textTooltipContent"
        class="admin-disabled-tooltip admin-text-tooltip"
        [style.left.px]="tooltipMouseX"
        [style.top.px]="tooltipMouseY">
        {{ textTooltipContent }}
      </div>

    </div>
  </main>

  <!-- Pop-up Editar Campanha -->
  <div *ngIf="showEditarCampanhaModal" class="modal-overlay" (click)="closeModalOnOverlayClick($event)">
    <div class="modal-content">
      <!-- Cabeçalho do Modal com o mesmo estilo -->
      <div class="modal-header">
        <h2 class="modal-title">Editar campanha</h2>
        <button class="modal-close-btn" (click)="closeEditarCampanhaModal()">
          ×
        </button>
      </div>

      <!-- Formulário -->
      <div class="modal-form">
        <!-- Primeira linha: Código e Tipo -->
        <div class="form-row">
          <div class="form-group">
            <input
              type="text"
              class="form-input blocked-readonly-field"
              placeholder="Código da campanha"
              [(ngModel)]="editCampaignForm.cdCampanha"
              readonly
              (mousemove)="onBlockedCodeMouseMove($event)"
              (mouseleave)="onBlockedCodeMouseLeave()"
              [ngModelOptions]="{ standalone: true }"
            >
          </div>
          <div class="form-group">
            <select
              class="form-select"
              [class.form-select-placeholder]="!editCampaignForm.idTipoCampanha"
              [(ngModel)]="editCampaignForm.idTipoCampanha"
              [ngModelOptions]="{ standalone: true }"
            >
              <option class="placeholder-option" [ngValue]="null">Tipo da campanha</option>
              <option
                *ngFor="let campaignType of editableCampaignTypes"
                [ngValue]="campaignType.idTipoCampanha">
                {{ campaignType.nmTipoCampanha }}
              </option>
            </select>
          </div>
        </div>

        <!-- Segunda linha: Descrição -->
        <div class="form-row">
          <div class="form-group full-width">
            <input
              type="text"
              class="form-input"
              placeholder="Nome da campanha"
              [(ngModel)]="editCampaignForm.nmCampanha"
              [ngModelOptions]="{ standalone: true }"
            >
          </div>
        </div>

        <!-- Terceira linha: Datas e Status -->
        <div class="form-row">
          <div class="form-group">
            <app-datetime-picker
              [dateOnly]="true"
              [autoSelectOnDateClick]="true"
              placeholder="Data de início"
              [(ngModel)]="dataInicio"
              [ngModelOptions]="{ standalone: true }"
              (dateChange)="onDataInicioChange($event)"
            ></app-datetime-picker>
          </div>
          <div class="form-group">
            <app-datetime-picker
              [dateOnly]="true"
              [autoSelectOnDateClick]="true"
              placeholder="Data de fim"
              [(ngModel)]="dataTermino"
              [ngModelOptions]="{ standalone: true }"
              [minDate]="dataInicio"
              (dateChange)="onDataTerminoChange($event)"
            ></app-datetime-picker>
          </div>
          <div class="form-group">
            <select
              class="form-select"
              [class.form-select-placeholder]="!editCampaignForm.flStatus"
              [(ngModel)]="editCampaignForm.flStatus"
              [ngModelOptions]="{ standalone: true }"
            >
              <option class="placeholder-option" value="">Status da campanha</option>
              <option value="A">Ativo</option>
              <option value="I">Inativo</option>
            </select>
          </div>
        </div>



        <!-- Botões -->
        <div class="form-buttons">
          <button class="cancel-btn" (click)="closeEditarCampanhaModal()">
            Cancelar
          </button>
          <button class="save-btn" [disabled]="isSavingEditCampaign" (click)="salvarEdicaoCampanha()">
            Salvar campanha
          </button>
        </div>
      </div>
    </div>
  </div>

    <!-- Pop-up Nova Campanha -->
  <div *ngIf="showNovaCampanhaModal" class="modal-overlay" (click)="closeModalOnOverlayClick($event)">
    <div class="modal-content">
      <!-- Cabeçalho do Modal com o mesmo estilo -->
      <div class="modal-header">
        <h2 class="modal-title">Cadastrar nova campanha</h2>
        <button class="modal-close-btn" (click)="closeNovaCampanhaModal()">
          ×
        </button>
      </div>

      <!-- Formulário -->
      <div class="modal-form">
        <!-- Primeira linha: Código e Tipo -->
        <div class="form-row">
          <div class="form-group">
            <input
              type="text"
              class="form-input"
              placeholder="Código da campanha"
              [(ngModel)]="newCampaignForm.cdCampanha"
              [ngModelOptions]="{ standalone: true }"
            >
          </div>
          <div class="form-group">
            <select
              class="form-select"
              [class.form-select-placeholder]="!newCampaignForm.idTipoCampanha"
              [(ngModel)]="newCampaignForm.idTipoCampanha"
              [ngModelOptions]="{ standalone: true }"
            >
              <option class="placeholder-option" [ngValue]="null">Tipo da campanha</option>
              <option
                *ngFor="let campaignType of editableCampaignTypes"
                [ngValue]="campaignType.idTipoCampanha">
                {{ campaignType.nmTipoCampanha }}
              </option>
            </select>
          </div>
        </div>

        <!-- Segunda linha: Descrição -->
        <div class="form-row">
          <div class="form-group full-width">
            <input
              type="text"
              class="form-input"
              placeholder="Nome da campanha"
              [(ngModel)]="newCampaignForm.nmCampanha"
              [ngModelOptions]="{ standalone: true }"
            >
          </div>
        </div>

        <!-- Terceira linha: Datas e Status -->
        <div class="form-row">
          <div class="form-group">
            <app-datetime-picker
              [dateOnly]="true"
              [autoSelectOnDateClick]="true"
              placeholder="Data de início"
              [(ngModel)]="dataInicio"
              [ngModelOptions]="{ standalone: true }"
              (dateChange)="onDataInicioChange($event)"
            ></app-datetime-picker>
          </div>
          <div class="form-group">
            <app-datetime-picker
              [dateOnly]="true"
              [autoSelectOnDateClick]="true"
              placeholder="Data de fim"
              [(ngModel)]="dataTermino"
              [ngModelOptions]="{ standalone: true }"
              [minDate]="dataInicio"
              (dateChange)="onDataTerminoChange($event)"
            ></app-datetime-picker>
          </div>
          <div class="form-group">
            <select
              class="form-select"
              [class.form-select-placeholder]="!newCampaignForm.flStatus"
              [(ngModel)]="newCampaignForm.flStatus"
              [ngModelOptions]="{ standalone: true }"
            >
              <option class="placeholder-option" value="">Status da campanha</option>
              <option value="A">Ativo</option>
              <option value="I">Inativo</option>
            </select>
          </div>
        </div>

        <!-- Upload de arquivo -->
        <div class="form-row">
          <div class="form-group full-width">
            <div class="custom-file-upload">
              <input
                type="file"
                id="arquivoCampanha"
                class="form-file"
                accept=".xlsx"
                (change)="onArquivoLeadsChange($event)"
              >
              <label for="arquivoCampanha" class="file-upload-label">
                <span class="file-placeholder" [class.file-placeholder-filled]="newCampaignForm.arquivoLeads">
                  {{ newCampaignForm.arquivoLeads?.name || 'Arquivo' }}
                </span>
                <span class="file-icon">
                  <img src="assets/icons/FileArrowUp.png" alt="Procurar arquivo">
                </span>
              </label>
            </div>
            <a href="#" class="file-template-link" (click)="baixarModeloArquivo($event)">
              Baixe aqui o modelo do arquivo
            </a>
          </div>
        </div>

        <!-- Botões -->
        <div class="form-buttons">
          <button class="cancel-btn" (click)="closeNovaCampanhaModal()">
            Cancelar
          </button>
          <button class="save-btn" [disabled]="isSavingNewCampaign" (click)="salvarCampanha()">
            Salvar campanha
          </button>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="showCampaignParticipantsModal" class="modal-overlay" (click)="closeModalOnOverlayClick($event)">
    <div class="modal-content campaign-participants-modal">
      <div class="modal-header campaign-participants-header">
        <div class="campaign-participants-heading">
          <h2 class="modal-title campaign-participants-title">Participantes da Campanha</h2>
          <p class="campaign-participants-subtitle">
            {{ selectedParticipantsCampaignTypeName || 'Tipo da campanha não informado' }}
          </p>
        </div>
        <button class="modal-close-btn" (click)="closeCampaignParticipantsModal()">
          ×
        </button>
      </div>

      <div class="campaign-participants-divider"></div>

      <div class="campaign-participants-content">
        <div *ngIf="campaignParticipantsLoading" class="campaign-participants-state">
          Carregando participantes...
        </div>

        <div
          *ngIf="!campaignParticipantsLoading && campaignParticipantsErrorMessage"
          class="campaign-participants-state campaign-participants-error">
          {{ campaignParticipantsErrorMessage }}
        </div>

        <div
          *ngIf="!campaignParticipantsLoading && !campaignParticipantsErrorMessage && campaignParticipants.length === 0"
          class="campaign-participants-state">
          Nenhum lead encontrado para esta campanha.
        </div>

        <div
          *ngIf="!campaignParticipantsLoading && !campaignParticipantsErrorMessage && campaignParticipants.length > 0"
          class="campaign-participants-table-wrapper">
          <table class="campaign-participants-table">
            <thead>
              <tr>
                <th
                  *ngFor="let column of campaignParticipantsColumns"
                  class="campaign-participants-sortable"
                  (click)="toggleCampaignParticipantsSort(column.key)">
                  <div class="campaign-participants-header-content">
                    <span>{{ column.label }}</span>
                    <img
                      src="assets/icons/alphabeticalIcon.png"
                      alt="Ordenar"
                      class="sort-icon"
                      [class.active]="getCampaignParticipantsSortOrder(column.key)"
                    >
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let participant of paginatedCampaignParticipants">
                <td>{{ participant.codigo }}</td>
                <td>{{ participant.cpf }}</td>
                <td>{{ participant.nome }}</td>
                <td>{{ participant.telefone }}</td>
                <td>{{ participant.email }}</td>
              </tr>
            </tbody>
          </table>

          <div class="pagination-container campaign-participants-pagination">
            <div class="pagination-content">
              <div class="rows-per-page">
                <label>Linhas por página:</label>
                <span class="campaign-participants-page-size">{{ campaignParticipantsPageSize }}</span>
              </div>

              <div class="page-counter">
                {{ getCampaignParticipantsDisplayedRange() }}
              </div>

              <div class="navigation">
                <button
                  class="nav-button"
                  (click)="previousCampaignParticipantsPage()"
                  [disabled]="!hasPreviousCampaignParticipantsPage()">
                  <img src="assets/icons/arrowBack.png" alt="Anterior" class="nav-icon">
                </button>
                <button
                  class="nav-button"
                  (click)="nextCampaignParticipantsPage()"
                  [disabled]="!hasNextCampaignParticipantsPage()">
                  <img src="assets/icons/arrowNext.png" alt="Próxima" class="nav-icon">
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
